import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import { Text } from 'shared/components'
import { dateWithTime } from 'constants/dateFormats'

const TargetEventColumnComponent = ({ value }) => {
  const { tournamentName } = value.eventDTO.tournamentDTO
  const matchStartTime = format(
    new Date(value.eventDTO.startTime),
    dateWithTime
  )
  return <Text size={11}>{`${tournamentName} ${matchStartTime}`}</Text>
}

TargetEventColumnComponent.propTypes = {
  value: PropTypes.shape().isRequired,
  fallbackSource: PropTypes.string,
}

export default TargetEventColumnComponent
